import React from 'react'
import styled from 'styled-components'
import { faFilter } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const SFilterButton = styled.button`
    color: #337ab7;
    cursor: pointer;
    border: none;
    background-color: transparent;

    &:hover {
        color: #23527c;
    }
`

export type FilterButtonProps = {
    action: () => void
}

export function FilterButton({ action }: FilterButtonProps): React.ReactElement {
    return (
        <SFilterButton onClick={action}>
            <FontAwesomeIcon icon={faFilter} />
        </SFilterButton>
    )
}
